export default __webpack_public_path__ + "static/media/about.ba6b7dcf.less";